import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMainCategories } from '../store/slices/mainCategorySlice';
import { fetchBanners } from '../store/slices/bannerSlice';
import { fetchProducts } from '../store/slices/productSlice';
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import Banner from "../components/home/Banner";
import ProductList from "../components/home/ProductList";
import Offers from "../components/home/Offers";
import DealsSection from "../components/home/DealsSection";
import MegaDealsSection from "../components/home/MegaDealsSection";
import RecentlyViewed from "../components/home/RecentlyViewed";
import CuratedProductLists from '../components/home/CuratedProductLists';
import PromoRow from '../components/home/PromoRow';
import FilteredProductShowcase from '../components/home/FilteredProductShowcase';
import MainCategoryGrid from '../components/home/MainCategoryGrid';
import '../styles/globals.css';
import CategoryList from '../components/home/CategoryList';

// ─── Promo Banner Row Data ───────────────────────────────────────────────────
const promoRow1 = [
    "https://rukminim1.flixcart.com/fk-p-flap/480/480/image/d78dda604e158c5c.jpg?q=50",
    "https://rukminim1.flixcart.com/fk-p-flap/480/480/image/6e9e6f6130cddc96.jpg?q=50",
    "https://rukminim1.flixcart.com/fk-p-flap/480/480/image/2073732fc5e1fef2.jpg?q=50",
];

const promoRow2 = [
    "https://rukminim1.flixcart.com/fk-p-flap/480/480/image/835b5bad61c96dfa.jpg?q=50",
    "https://rukminim1.flixcart.com/fk-p-flap/480/480/image/134a87c3e35addf4.jpg?q=50",
    "https://rukminim1.flixcart.com/fk-p-flap/480/480/image/6f7597ab853d5cd1.jpg?q=50",
];

const beautyBanners = [
    "https://images.unsplash.com/photo-1612817288484-6f916006741a?q=80&w=1600&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?q=80&w=1600&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1596462502278-27bfdc4033c8?q=80&w=1600&auto=format&fit=crop",
];

// ─── Component ────────────────────────────────────────────────────────────────
function Home() {
    const dispatch = useDispatch();
    const { mainCategories, loading: mcLoading } = useSelector((state) => state.mainCategory);
    const { banners, loading: bannerLoading } = useSelector((state) => state.banner);
    const { products, loading: pLoading } = useSelector((state) => state.product);

    useEffect(() => {
        dispatch(fetchMainCategories());
        dispatch(fetchBanners({ type: 'home' }));
        dispatch(fetchProducts({ limit: 40 }));
    }, [dispatch]);

    const homeBanners = banners.filter(b => b.type === 'home').sort((a, b) => a.priority - b.priority);

    return (
        <div className="home-page-container">
            <style>
                {`
                .home-page-container {
                    background-color: var(--color-bg);
                    min-height: 100vh;
                    padding-top: 128px;
                    box-sizing: border-box;
                }
                .promo-banner:hover { opacity: 0.95; }

                @media (max-width: 900px) {
                    .home-page-container {
                        padding-top: 136px !important;
                    }
                }

                @media (max-width: 600px) {
                    .home-page-container {
                        padding-top: 136px !important;
                    }
                }

                @media (max-width: 480px) {
                    .home-page-container {
                        padding-top: 136px !important;
                    }
                }
                `}
            </style>

            <div style={{ margin: "auto", }}>
                <Header />

                <CategoryList showImage={false} />
                {/* Primary Hero Slider */}
                <div style={{ padding: "0", marginTop: "0" }}>
                    <Banner
                        banners={homeBanners}
                        loading={bannerLoading}
                        height={{ base: "180px", md: "400px" }}
                    />
                </div>
                {/* Mega Deals Section - Flash Sale */}
               
                {/* Main Category Grid Section */}
                <MainCategoryGrid />




                {/* Offers Row
                <div style={{ marginBottom: "12px", backgroundColor: "white", borderRadius: "4px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)", padding: "16px" }}>
                    <Offers />
                </div> */}

                {/* Top Picks */}
                {/* <div style={{ backgroundColor: "white", borderRadius: "4px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)", marginBottom: "12px" }}>
                    <ProductList />
                </div> */}

                {/* Deals Section */}
                {/* <div style={{ backgroundColor: "white", borderRadius: "4px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)", marginBottom: "12px" }}>
                    <DealsSection />
                </div> */}


                {/* Filtered Product Showcase with Real Data */}
                <FilteredProductShowcase />

                {/* Recently Viewed Section */}
                <div style={{ backgroundColor: "white", borderRadius: "4px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)", marginBottom: "12px" }}>
                    <RecentlyViewed />
                </div>

                {/* Mobiles Promotional Banner */}
                {/* <div style={{ marginBottom: "12px", borderRadius: "12px", overflow: "hidden", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
                    <img
                        src="/mobiles_promotion_banner.png"
                        alt="Best of Mobiles Promotion"
                        style={{ width: "100%", height: "240px", objectFit: "cover", display: "block" }}
                    />
                </div> */}




                {/* Dynamic Category Sections */}
                {/* {mcLoading || pLoading ? (
                    <div style={{ textAlign: 'center', padding: '40px' }}>Loading Amazing Deals...</div>
                ) : (
                    mainCategories.map((mc, index) => {
                        // Filter products that belong to this main category
                        const mcProducts = products.filter(p => p.main_category_id === mc._id || p.main_category === mc._id);

                        if (mcProducts.length === 0) return null;

                        const items = mcProducts.slice(0, 6).map(prod => {
                            const discount = Math.round(((prod.mrp - prod.price) / prod.mrp) * 100);
                            return {
                                name: prod.name,
                                deal: discount > 0 ? `Min. ${discount}% Off` : "Great Deal",
                                image: (prod.images && prod.images.length > 0) ? prod.images[0].url : 'https://via.placeholder.com/150',
                                price: `₹${prod.price.toLocaleString()}`,
                                originalPrice: `₹${prod.mrp.toLocaleString()}`,
                                rating: 4.5
                            };
                        });

                        return (
                            <React.Fragment key={mc._id}>
                                <CategorySection
                                    title={`Best of ${mc.name}`}
                                    viewAllLink={`/products?main_category=${mc._id}`}
                                    items={items}
                                    accentColor={index % 2 === 0 ? "var(--color-primary)" : "#6d4c41"}
                                />
                                {index === 0 && <PromoRow urls={promoRow1} />}
                                {index === 1 && <TopBrandsSection />}
                                {index === 2 && <PromoRow urls={promoRow2} />}
                                {index === 3 && (
                                    <div style={{ marginBottom: "12px", backgroundColor: "red", height: "200px", borderRadius: "8px", overflow: "hidden" }}>
                                        <Banner images={beautyBanners} height={{ base: "900px", md: "600px" }} />
                                    </div>
                                )}
                            </React.Fragment>
                        );
                    })
                )} */}

                {/* <div style={{ marginBottom: "12px" }}>
                    <CuratedProductLists />
                </div> */}

            </div>

            <Footer />
        </div>
    );
}

export default Home;